<template lang="pug">
  v-container(fluid grid-list-md)
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.organizations') }}
      v-container.pt-0
        v-card-title.mt-0
          v-text-field(v-model='search', append-icon='search', clearable label='Search', single-line, hide-details)
        v-data-table(:headers='headers',
          :items='organizations',
          item-key="CSPID",
          :loading='loading',
          :search="search",
          :pagination.sync='pagination')
          template(slot='items', slot-scope='props')
            tr(@click='viewOrganization(props.item)')
              td.text-xs-left.pointer {{ $moment(props.item.createDateTime).format('MM/DD/YYYY') }}
              td.text-xs-left.pointer.small-td {{ props.item.organizationName }}
              td.text-xs-left.pointer {{ props.item.ownerName }}
              td.text-xs-left.pointer {{ props.item.primaryPhone | USPhoneNumber }}
              td.text-xs-left.pointer {{ props.item.secondaryPhone | USPhoneNumber }}
              td.text-xs-left.pointer.small-td {{ props.item.primaryEmail }}
              
          v-alert(slot='no-results', :value='true', color='error', icon='warning')
            | Your search for "{{ search }}" found no results.
</template>
<script>
import organizationsService from "../service.js";

export default {
  props: ['organizations', 'loading', 'title'],
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.createdAt"),
          align: "left",
          sortable: true,
          value: "createDateTime"
        },
        {
          text: this.$t("labels.name"),
          value: "organizationName",
          sortable: true,
          width: "25%"
        },
        {
          text: this.$t("labels.ownerName"),
          value: "ownerName",
          sortable: true
        },
        {
          text: this.$t("labels.primary"),
          value: "primaryPhone",
          sortable: true
        },
        {
          text: this.$t("labels.second"),
          value: "primaryEmail",
          sortable: true
        },
        {
          text: this.$t("labels.email"),
          value: "primaryEmail",
          sortable: true
        },
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "businessName"
      }
    };
  },
  methods: {
    viewOrganization(data) {
      this.$router.push({ path: `/organization/profile/${data.organizationID}` });
    }
  }
};
</script>
